import { useEffect, useState } from "react";
import { BankAccount } from "../../types/banks/BankAccount";
import { useFamily } from "./useFamily";
import { FirestoreBankAccountRepository } from "../../../infrastructure/repositories/BankAccountRepository";

export function useFamilyBankAccounts() {
  const { family, loading: familyLoading } = useFamily();
  const [familyBankAccounts, setFamilyBankAccounts] = useState<{
    [appUserId: string]: BankAccount[];
  }>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (familyLoading) {
      return;
    }

    if (!family || !family.members || family.members.length === 0) {
      setLoading(false);
      return;
    }

    const repository = new FirestoreBankAccountRepository();
    const unsubscribeFunctions: Array<() => void> = [];

    family.members.forEach((appUserId) => {
      const unsubscribe = repository.observeBankAccountsByAppUserId(
        appUserId,
        (accounts) => {
          setFamilyBankAccounts((prev) => ({
            ...prev,
            [appUserId]: accounts,
          }));
          setLoading(false);
        },
        (err) => {
          console.error(
            `Error fetching bank accounts for user ${appUserId}:`,
            err,
          );
          setError(err);
          setLoading(false);
        },
      );
      unsubscribeFunctions.push(unsubscribe);
    });

    return () => {
      unsubscribeFunctions.forEach((unsubscribe) => unsubscribe());
    };
  }, [family, familyLoading]);
  console.debug("familyBankAccounts", familyBankAccounts);
  return { familyBankAccounts, loading, error };
}
